import { useStore } from 'hooks/useStore';
import TargetMarketPlan from './TargetMarketPlan';
import classes from './targetMarketScreen.module.scss';
import { observer } from 'mobx-react';
import { useEffect } from 'react';

const TargetMarketShareScreen = () => {
  const {
    MSPlanStore: {
      conceptSearchInput,
      isConceptDetailsLoading,
      conceptDetails,
      getTargetMarketScreenData,
    },
  } = useStore();

  useEffect(() => {
    if (conceptDetails?.gfc) {
      getTargetMarketScreenData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conceptDetails]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.targetMarketContainer}>
      {conceptSearchInput.length <= 20 && !isConceptDetailsLoading && conceptDetails?.gfc === 0 ? (
        <div className={classes.messageContainer}>
          <h2>Search a concept to see Sales plan</h2>
        </div>
      ) : (
        <TargetMarketPlan />
      )}
    </div>
  );
};

export default observer(TargetMarketShareScreen);
